module.exports = __webpack_public_path__ + "static/media/sprite_y.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/images/default/sprite_y.png
// module id = ./src/CSS/assets-minified/images/default/sprite_y.png
// module chunks = 0